export default {"status-icon":"icon-status-wrapper-module__status-icon___PomWs"}
import '/home/jenkins/agent/workspace/_release_release_t3-widgets_15.1/packages/common/widgets/src/components/icon-status-wrapper/icon-status-wrapper.module.css'
